module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('select', {
    staticClass: "form-control",
    attrs: {
      "name": _vm.name
    }
  }, [_c('option', {
    attrs: {
      "hidden": "",
      "disabled": "",
      "selected": ""
    },
    domProps: {
      "selected": true
    }
  }, [_vm._v(_vm._s(_vm.placeholder))]), _vm._v(" "), _vm._l((_vm.options), function(item) {
    return _c('option', {
      domProps: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-671668fd!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Lesson1/components/SelectOptionGroup.vue
// module id = 32
// module chunks = 0